import { EMPTY_STRING } from '../../misc/strings.constants';

export const symbolRetriever = currency => {
  switch (currency) {
    case null:
    case '':
    case undefined:
      return EMPTY_STRING;
    case 'US Dollar':
    case 'USD':
    case 'United States Dollar':
      return '$';
    case 'Euro':
    case 'EUR':
    case 'European Euro':
      return '€';
    case 'Great Britain Pound':
    case 'GBP':
    case 'British Pound':
    case 'Pound Sterling':
    case 'UK Pound':
      return '£';
    case 'Japanese Yen':
    case 'JPY':
      return '¥';
    case 'Swiss Franc':
    case 'CHF':
      return '₣';
    case 'Canadian Dollar':
    case 'CAD':
      return 'C$';
    case 'Australian Dollar':
    case 'AUD':
      return 'A$';
    case 'Indian Rupee':
    case 'INR':
      return '₹';
    case 'Chinese Yuan':
    case 'CNY':
    case 'RMB':
      return '¥';
    default:
      return '$'; // fallback to dollar sign
  }
};
